import Page from '../Shared/Page/Page';

export default function Contact() {
	return (
		<Page title='Contact Peer Gaming'>
			<p>At this time we don't care what you think. Do not contact.</p>
		</Page>
	);
}
